import { render, staticRenderFns } from "./FaqItem.vue?vue&type=template&id=2ef1f57a&scoped=true&"
import script from "./FaqItem.vue?vue&type=script&lang=ts&"
export * from "./FaqItem.vue?vue&type=script&lang=ts&"
import style0 from "./FaqItem.vue?vue&type=style&index=0&id=2ef1f57a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef1f57a",
  null
  
)

export default component.exports